module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_1.3f4e95fc.pdf";